import {
  ADD_WORKSHIFTS_FAILED,
  ADD_WORKSHIFTS_SUCCESS,
  CANCEL_DIALOG,
  CANCEL_EDIT_WORK_SHIFT,
  CLOSE_WORKSHIFT_FORM_DIALOG,
  CLOSE_WORKSHIFT_SNACKBAR,
  DELETE_WORKSHIFT,
  GET_BILLABLE_HOURS,
  GET_BILLABLE_HOURS_SUCCESS,
  GET_SIGNED_LIGHT_ENTREPRENEUS_SUCCESS,
  GET_WORKSHIFTS,
  GET_WORKSHIFTS_SUCCESS,
  GET_WORKSHIFT_BY_ID_SUCCESS,
  LOCATION_CHANGE,
  REMOVE_WORKSHIFT_SUCCESS,
  SHOW_WORKSHIFT_FORM_DIALOG,
  UPDATE_WORKSHIFT_FAILED,
  UPDATE_WORKSHIFT_SUCCESS,
  WORKSHIFT_BY_EMAIL,
  WORKSHIFT_PAGE_CHANGE
} from '../../constants/employer'

const initialState = {
  workshifts: [],
  billableHours: [],
  showDeleteDialog: false,
  deleteWorkshiftid: '',
  deleteWorkshiftItemid: '',
  isEditWorkshift: false,
  showAddSnackbar: false,
  showFailedAddSnackbar: false,
  showEditSnackbar: false,
  showFailedEditSnackbar: false,
  signedLightEntrepreneurs: [],
  emailSelectionList: [],
  emailSelected: '',
  workshiftsFilter: [],
  billableHoursFilter: [],
  isFilterEmail: false,
  getWorkshiftDataSuccess: false,
  getBillableHourDataSuccess: false,
  allWaitingForConfirmation: false, // Check when edit work shift
  selected: 0,
  deleteWorkshiftSuccess: false,
  showWorkshiftForm: false
}

const workshiftsReducer = (state = initialState, action) => {
  switch (action.type) {
    case WORKSHIFT_PAGE_CHANGE:
      return Object.assign(
        {},
        { ...state },
        {
          selected: action.selected.selected
        }
      )
    case GET_SIGNED_LIGHT_ENTREPRENEUS_SUCCESS:
      const data = action.data
      const uniqueData = Array.from(new Set(data.map(JSON.stringify))).map(
        JSON.parse
      )
      return Object.assign(
        {},
        { ...state },
        {
          signedLightEntrepreneurs: uniqueData,
          emailSelectionList: uniqueData
        }
      )
    case GET_WORKSHIFTS:
    case GET_BILLABLE_HOURS:
      return Object.assign(
        {},
        { ...state },
        {
          getWorkshiftDataSuccess: false,
          getBillableHourDataSuccess: false
        }
      )

    case GET_WORKSHIFTS_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          workshifts: action.data,
          getWorkshiftDataSuccess: true
        }
      )

    case GET_BILLABLE_HOURS_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          billableHours: action.data,
          getBillableHourDataSuccess: true
        }
      )
    case WORKSHIFT_BY_EMAIL:
      const emailSelected = action.email
      let workshiftsFilter, billableHoursFilter
      if (emailSelected !== 'all') {
        workshiftsFilter = state.workshifts.filter(
          (item) => item.offershift_to === emailSelected
        )
        billableHoursFilter = state.billableHours.filter(
          (item) => item.offershift_to === emailSelected
        )
      } else {
        workshiftsFilter = state.workshifts
        billableHoursFilter = state.billableHours
      }
      return Object.assign(
        {},
        { ...state },
        {
          isFilterEmail: true,
          emailSelected: action.email,
          workshiftsFilter: workshiftsFilter,
          billableHoursFilter: billableHoursFilter
        }
      )

    case GET_WORKSHIFT_BY_ID_SUCCESS:
      const workshift_edit_data = action.data
      // Check if all workshift_status_entrepreneur are "waiting for confirmation"
      const allWaitingForConfirmation = workshift_edit_data.dateRows.every(
        (item) => item.workshift_status_entrepreneur === 0
      )

      return Object.assign(
        {},
        { ...state },
        {
          isEditWorkshift: true,
          allWaitingForConfirmation: allWaitingForConfirmation
        }
      )
    case CANCEL_EDIT_WORK_SHIFT:
      return Object.assign(
        {},
        { ...state },
        {
          isEditWorkshift: false
        }
      )
    case CLOSE_WORKSHIFT_SNACKBAR:
      return Object.assign(
        {},
        { ...state },
        {
          showAddSnackbar: false,
          showFailedAddSnackbar: false,
          showEditSnackbar: false,
          showFailedEditSnackbar: false
        }
      )
    case ADD_WORKSHIFTS_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          showAddSnackbar: true,
          showFailedAddSnackbar: false
        }
      )
    case ADD_WORKSHIFTS_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          showAddSnackbar: false,
          showFailedAddSnackbar: true
        }
      )
    case UPDATE_WORKSHIFT_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          isEditWorkshift: false,
          showEditSnackbar: true,
          showFailedEditSnackbar: false
        }
      )
    case UPDATE_WORKSHIFT_FAILED:
      return Object.assign(
        {},
        { ...state },
        {
          showEditSnackbar: false,
          showFailedEditSnackbar: true
        }
      )

    case DELETE_WORKSHIFT:
      return Object.assign(
        {},
        { ...state },
        {
          showDeleteDialog: true,
          deleteWorkshiftid: action.workshiftid,
          deleteWorkshiftItemid: action.workshift_itemid
        }
      )
    case REMOVE_WORKSHIFT_SUCCESS:
      return Object.assign(
        {},
        { ...state },
        {
          showDeleteDialog: false,
          deleteWorkshiftid: '',
          deleteWorkshiftItemid: '',
          deleteWorkshiftSuccess: true
        }
      )
    case CANCEL_DIALOG:
      return Object.assign(
        {},
        { ...state },
        {
          showDeleteDialog: false,
          deleteWorkshiftid: '',
          deleteWorkshiftItemid: '',
          deleteWorkshiftSuccess: false
        }
      )
    case SHOW_WORKSHIFT_FORM_DIALOG:
      return Object.assign({}, state, {
        showWorkshiftForm: true
      })
    case CLOSE_WORKSHIFT_FORM_DIALOG:
      return Object.assign({}, state, {
        showWorkshiftForm: false,
        isEditWorkshift: false
      })
    case LOCATION_CHANGE:
      return Object.assign(
        {},
        { ...state },
        {
          isEditWorkshift: false,
          showAddSnackbar: false,
          showFailedAddSnackbar: false,
          showEditSnackbar: false,
          showFailedEditSnackbar: false,
          getWorkshiftDataSuccess: false,
          getBillableHourDataSuccess: false,
          deleteWorkshiftSuccess: false
        }
      )
    default:
      return state
  }
}

// Format workshift data
// function formatWorkshift(workshifts) {
//   const result = []
//   const workshiftMap = {}

//   workshifts.forEach((shift) => {
//     const {
//       workshift_id,
//       workshift_itemid,
//       workshift_date,
//       workshift_start_time,
//       workshift_endtime,
//       workshift_status,
//       actualhours_billed,
//       workshift_status_entrepreneur
//     } = shift

//     // If workshift_id is not already in the map, create a new entry
//     if (!workshiftMap[workshift_id]) {
//       workshiftMap[workshift_id] = {
//         workshift_id: shift.workshift_id,
//         offershift_to: shift.offershift_to,
//         location: shift.location,
//         workshift_lastdate: shift.workshift_lastdate,
//         task_description: shift.task_description,
//         additional_info: shift.additional_info,
//         workshiftItems: []
//       }
//       result.push(workshiftMap[workshift_id])
//     }

//     // Add the current shift item to the workshiftItems array
//     workshiftMap[workshift_id].workshiftItems.push({
//       workshift_itemid,
//       workshift_date,
//       workshift_start_time,
//       workshift_endtime,
//       workshift_status,
//       actualhours_billed,
//       workshift_status_entrepreneur
//     })
//   })

//   return result
// }

// function formatBillableHour(billableHour) {
//   const result = []
//   const billableHourMap = {}

//   billableHour.forEach((el) => {
//     const {
//       workshift_id,
//       workshift_itemid,
//       workshift_date,
//       workshift_start_time,
//       workshift_endtime,
//       workshift_status,
//       workshift_status_entrepreneur,
//       entrepreneurs_rating,
//       actualhours_billed,
//       workshift_additional_comments,
//       actualworkshift_starttime,
//       actualworkshift_endtime,
//       time_spent
//     } = el

//     // If workshift_id is not already in the map, create a new entry
//     if (!billableHourMap[workshift_id]) {
//       billableHourMap[workshift_id] = {
//         workshift_id: el.workshift_id,
//         offershift_to: el.offershift_to,
//         location: el.location,
//         workshift_lastdate: el.workshift_lastdate,
//         task_description: el.task_description,
//         additional_info: el.additional_info,
//         workshift_additional_comments: el.workshift_additional_comments,
//         workshiftItems: []
//       }
//       result.push(billableHourMap[workshift_id])
//     }

//     // Add the current shift item to the workshiftItems array
//     billableHourMap[workshift_id].workshiftItems.push({
//       workshift_itemid,
//       workshift_date,
//       workshift_start_time,
//       workshift_endtime,
//       workshift_status,
//       actualhours_billed,
//       workshift_additional_comments,
//       workshift_status_entrepreneur,
//       entrepreneurs_rating,
//       actualworkshift_starttime,
//       actualworkshift_endtime,
//       time_spent
//     })
//   })

//   return result
// }

export default workshiftsReducer
